export type Docs = {
  facsimile: string
  foglioInformativo: string
  guidaABF: string
  centraleRischi: string
  tegmAntiusura: string
  informativaPrivacy: string
  informativaSic: string
  biometricDisclosure: string
  termsAndConditions: string
  ibanGuide: string
  policy231: string
}

export const getDocsByClientSource = (partnerType?: string): Docs => {
  const docs: Docs = {
    foglioInformativo: "https://www.bancacfplus.it/wp-content/uploads/2026/04/Foglio-informativo-n.-11-Digital.pdf",
    guidaABF: "https://www.bancacfplus.it/wp-content/uploads/2022/01/ABF-in-parole-semplici.pdf",
    centraleRischi:
      "https://www.bancacfplus.it/wp-content/uploads/2023/02/Guida-sulla-centrale-dei-rischi_22-dicembre-2021.pdf",
    tegmAntiusura: "https://www.bancacfplus.it/wp-content/uploads/2025/10/cs-ril-trim-antiusura-30.09.2025.pdf",
    informativaPrivacy:
      "https://www.bancacfplus.it/wp-content/uploads/2025/07/Informativa-trattamento-dei-dati-personali-nellambito-del-Digital-Lending.pdf",
    informativaSic:
      "https://www.bancacfplus.it/wp-content/uploads/2026/04/Informativa-sui-sistemi-di-informazioni-creditizie-SIC.pdf",
    facsimile: "https://static.bancacfplus.it/contratto-finanziamento-digital-lending.pdf",
    biometricDisclosure: "https://static.bancacfplus.it/informativa_trattamento_dati_biometrici.pdf",
    termsAndConditions: "https://static.bancacfplus.it/contratto-termini-condizione-piattaforma.pdf",
    policy231: "https://static.bancacfplus.it/All.1-Informativa_ai_sensi_231-07.pdf",
    ibanGuide: "https://static.bancacfplus.it/Guida_Estratto_Conto_BancaCF%2B.pdf"
  }

  switch (partnerType) {
    case "poste":
      return {
        ...docs,
        foglioInformativo: "https://static.bancacfplus.it/foglio-informativo-poste-digital-lending.pdf",
        facsimile: "https://static.bancacfplus.it/contratto-finanziamento-digital-lending-poste.pdf"
      }
    default:
      return docs
  }
}
